export enum ButtonKind {
    Primary = "sb-button sb-button-primary",
    Secondary = "sb-button sb-button-secondary",
    SecondaryOnDark = "sb-button sb-button-secondary-on-dark",
    Tertiary = "sb-button sb-button-tertiary",
    Link = "sb-button sb-button-link",
    Neutral = "sb-button sb-button-neutral",
    NeutralSecondary = "sb-button sb-button-neutral-secondary",
    NeutralSecondaryOnDark = "sb-button sb-button-neutral-secondary-on-dark",
    NeutralTertiary = "sb-button sb-button-neutral-tertiary",
    NeutralLink = "sb-button sb-button-neutral-link",
    Danger = "sb-button sb-button-danger", 
    DangerSecondary = "sb-button sb-button-danger-secondary",
    DangerSecondaryOnDark = "sb-button sb-button-danger-secondary-on-dark",
    DangerTertiary = "sb-button sb-button-danger-tertiary",
    DangerLink = "sb-button sb-button-danger-link",
    Warning = "sb-button sb-button-warning",
    WarningSecondary = "sb-button sb-button-warning-secondary",
    WarningSecondaryOnDark = "sb-button sb-button-warning-secondary-on-dark",
    WarningTertiary = "sb-button sb-button-warning-tertiary",
    WarningLink = "sb-button sb-button-warning-link",
    Circle = "sb-button sb-button-circle",
    FormField = "sb-button sb-button-form-field",
}

export enum ButtonSize {
    Small = "sb-button-small",
    Medium = "sb-button-medium", // Medium is the default button size in bootstrap
    Large = "sb-button-large",
    XLarge = "sb-button-xlarge"
}

export enum ButtonGroupSize {
    Small = "sb-button-group sb-button-group-small",
    Medium = "sb-button-group sb-button-group-medium", // Medium is the default button size in bootstrap
    Large = "sb-button-group sb-button-group-large",
    XLarge = "sb-button-group sb-button-group-xlarge"
}

export enum ButtonRole {
    Primary = "Primary",
    Secondary = "Secondary",
    Tertiary = "Tertiary",
}

export enum MenuButtonMode {
    Default,
    TextOnly,
    Custom,
    IconOnly
}

export enum MenuDivider {
    Above,
    Below,
    None,  // default
    Both   // not implemented yet
}



/**
 *  By default, the menu will display below (y-axis), after (x-axis)
 *  @see {@link https://material.angular.io/components/menu/overview#customizing-menu-position}
 */
export type MenuXPosition = "before" | "after";
